<template>
    <div>
        <component style="display: none" :is="show_document"></component>

        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol>
                                <strong>{{ $t('chequesPayable') }}</strong>
                            </CCol>
                            <CCol style="text-align: end;">


                            </CCol>

                        </CRow>
                        <CRow>
                            <CCol col="3">
                                <date-picker

                                        :label="$t('components.startDate')"
                                        v-model="start_date"></date-picker>
                            </CCol>
                            <CCol col="3">
                                <date-picker
                                        :label="$t('components.endDate')"
                                        v-model="end_date"></date-picker>

                            </CCol>
<!--                            <CCol col="3">-->
<!--                                <CSelect :value.sync="selected_paid_type"-->
<!--                                         :options="[{label:$t('all'),value:0},{label:$t('components.buy'),value:1},{label:$t('cheque'),value:2}]"-->
<!--                                />-->
<!--                            </CCol>-->
                            <CCol col="1">
                                <CButton @click="get_all_data" color="dark"
                                         size="sm">
                                    <CIcon size="sm" name="cil-zoom"/>
                                </CButton>
                            </CCol>
                        </CRow>

                    </CCardHeader>
                    <CCardBody>

                        <CDataTableFixed
                                :items="items_sell_filtered"
                                :fields="fields"
                                column-filter
                                @row-clicked="table_row_clicked"

                                :items-per-page="20"
                                hover
                                sorter
                                border
                                striped
                                :sorter-value="{column:'recId',asc:false}"
                                pagination
                        >
                            <template #row="{item,index}">
                                <td>
                                    <p class="text-center">{{ index + 1 }}</p>
                                </td>
                            </template>
                            <template #surName="{item}">
                                <td>
                                    <p  v-if="item.surName">{{ item.surName }}</p>
                                </td>
                            </template>
                            <template #dueDate="{item}">
                                <td>
                                    <p class="text-center" >{{ get_date(item.dueDate) }}</p>
                                </td>
                            </template>
                            <template #mainDocDate="{item}">
                                <td>
                                    <p class="text-center" >{{ get_date(item.mainDocDate) }}</p>
                                </td>
                            </template>
                            <template #accountNo="{item}">
                                <td>
                                    <p class="text-center">{{item.accountNo }}</p>
                                </td>
                            </template>
                            <template #personCode="{item}">
                                <td>
                                    <p class="text-center">{{item.personCode }}</p>
                                </td>
                            </template>
                            <template #masterCode="{item}">
                                <td>
                                    <p class="text-center">{{item.masterCode }}</p>
                                </td>
                            </template>
                            <template #amount="{item}">
                                <td>
                                    <p style="text-align: right">{{ get_currency(item.amount) }}</p>
                                </td>
                            </template>
                            <template #balance="{item}">
                                <td>
                                    <p style="text-align: right">{{ get_currency(item.balance) }}</p>
                                </td>
                            </template>
                            <template #resultType="{item}">
                                <td>
                                    <p v-if="item.resultType==1">{{ $t('buy') }}</p>
                                    <p v-if="item.resultType==2">{{ $t('cheque') }}</p>
                                </td>
                            </template>

                            <template #caption>
                                <tr class="total-table">

                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ $t('totalCirculation') }}</td>
                                    <td >
                                        {{ get_currency(Math.abs(calculate_items(items_sell_filtered, 'amount'))) }}
                                    </td>
                                    <td >

                                        {{ get_currency(Math.abs(calculate_items(items_sell_filtered, 'balance'))) }}</td>


                                </tr>

                            </template>




                        </CDataTableFixed>
                    </CCardBody>

                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'

    const simulateAsyncOperation = fn => {
        setTimeout(fn, 200)
    }
    var items_data = [];


    export default {
        name: 'Login',
        components: {
            Treeselect,
            'test-dynamic': () => import('../documents/PrintDocument'),

        },
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                show_document: 'test-dynamic',
                printed_doc_id: 0,
                name: '',


                start_date: '',
                end_date: '',
                submit_refer: 0,
                refer_person: null,
                selected_template: 0,
                id_checkbox_items: [],
                item_sell_array: [],
                paid_type_items: [],

                selected_paid_type: 0,
                items_sell_filtered: [],
                items_sell: [],
                table_clicks_timer: '',
                table_clicks: 0,


                fields: [
                    {key: 'row', label: this.$t('tables.sharp'), sorter: false, _style: 'text-align:center;width:2%'},
                    {key: 'personCode', label: this.$t('tables.code'), _style: 'width:7%'},
                    {key: 'personName', label: this.$t('name'), _style: 'width:15%'},
                    {key: 'surName', label: this.$t('lastName'), _style: 'width:15%'},
                    {key: 'dueDate', label: this.$t('payDueDate'), _style: 'width:15%'},
                    {key: 'masterCode', label: this.$t('referenceNo'), _style: 'width:10%'},
                    {key: 'mainDocDate', label: this.$t('payDate'), _style: 'width:10%'},
                    {key: 'accountNo', label: this.$t('AccountNo'), _style: 'width:10%'},
                    {key: 'amount', label: this.$t('components.amount'), _style: 'width:10%'},
                    // {key: 'payed', label: this.$t('payed'), _style: 'width:10%'},
                    // {key: 'balance', label: this.$t('tables.balance'), _style: 'width:10%'},
                    // {key: 'docDate', label: this.$t('tables.date'), _style: 'width:10%'},
                    // {key: 'masterCode', label: this.$t('tables.factorId'), _style: 'width:10%'},
                    // {key: 'partyCode', label: this.$t('customerCode'), _style: 'width:10%'},
                    // {key: 'partyName', label: this.$t('customerName'), _style: 'width:20%'},
                    // {key: 'createdBy', label: this.$t('SalesPerson'), _style: 'width:15%'},
                    // {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'width:15%'},

                    // {key: 'payType', label: this.$t('PaymentStatus'), _style: 'width:7%'},

                    // {key: 'operation', label: "", _style: 'width:3%', sorter: false, filter: false},
                    // {key: 'select', label: "", _style: 'width:3%', sorter: false, filter: false},

                ],

                details: [],

                status_form: 0,
                load_persons({action, searchQuery, callback}) {
                    var self = this;

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);

                            axios.post('GetUsers', formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {

                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
                    }
                },

            }
        }, mounted() {

            this.start_date = this.get_day_before_today_in_day(4);
            this.end_date = this.get_today();

            this.$root.root_validate_errors = [];

            this.get_all_data();

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
            bus.$on("delete_re_order_called", (data) => {
                this.get_all_data();
            });
        }, watch: {
            '$route.params.person_id': function () {
                this.get_all_data();
            },
            // 'start_date': function () {
            //     this.get_all_data();
            // },
            // 'end_date': function () {
            //     this.get_all_data();
            // },
            'selected_paid_type': function () {
                if (this.selected_paid_type == 0) {
                    this.items_sell_filtered = this.items_sell

                } else {
                    this.items_sell_filtered = this.items_sell.filter(x => x.resultType == this.selected_paid_type);
                }
            }

        },
        methods: {
            table_row_clicked(item, index) {

                this.table_clicks++;
                if (this.table_clicks == 1) {
                    this.table_clicks_timer = setTimeout(() => {
                        // this.result.push(event.type);
                        this.table_clicks = 0
                    }, 500);
                } else if (this.table_clicks > 1) {
                    clearTimeout(this.table_clicks_timer);
                  this.table_clicks = 0

                    this.goShowDocument(item)

                }

            },
            get_all_data() {
                this.get_lists_sell();

            },

            get_lists_sell() {

                var self = this;
                var formData = new FormData();

                var url = "GetAccountPayableList";

                formData.append("FirstDate", self.start_date);
                formData.append("SecondDate", self.end_date);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    if (content_data.statusCode == 0) {

                        self.items_sell = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                        // self.items_sell.forEach(function (val) {
                        //     val.totalPrice = parseFloat(val.totalPrice);
                        // })
                        self.items_sell_filtered = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });


            },


            goReturnDocument(item) {
                this.$router.push({
                    path: '/dashboard/documents/return/' + item.recId + "/false",
                    params: {passed_data: "salam hamidddd"}
                });
            },
            goShowDocument(item) {
// if(item.isReorder==3){
                // this.$router.push({path: '/dashboard/documents/show/' + item.recId});
// }else{
//                 this.$router.push({path: '/dashboard/documents/show/' + item.recId});
// }
              window.open('/dashboard/documents/show/' + item.recId)

            },
            goPrintDocument(item) {
                bus.$emit("print_confirm", item.recId);


            },
            AddRefer(item) {
                this.submit_refer = item.recId;
            },

            AddAllRefer() {
                this.submit_refer = -1;
                if (this.id_checkbox_items.length == 0) {
                    console.log("validate form is false" + this.validate_errors);
                    this.submit_refer = 0;

                }
            },

            AddReOrder() {
                if (this.id_checkbox_items.length > 0) {
                    for (var i = 0; i < this.id_checkbox_items.length; i++) {
                        this.add_factor_to_reorder(this.id_checkbox_items[i]);
                    }
                }
            },

            add_factor_to_reorder(id) {
                let self = this;


                let url;
                // if (this.status_form == 0) {
                url = "AddReOrder";
                // }
                const formData = new FormData();

                formData.append('Id', id);

                axios.post(url, formData, {}).then((res) => {


                    self.submit_refer = 0;
                    if (self.id_checkbox_items[self.id_checkbox_items.length - 1] == id) {
                        self.id_checkbox_items = [];
                        self.$root.modal_component.show_api_response_modals(res);
                        bus.$emit('reorder_added')
                    }
                    self.get_all_data();


                })
                    .catch(function (error) {

                        console.log(error);
                    });
            },

            insert_refer() {
                let self = this;

                if (this.submit_refer != -1) {


                    this.id_checkbox_items = [];
                } else {
                    if (this.id_checkbox_items.length == 0) {
                        console.log("validate form is false" + this.validate_errors);
                        self.submit_refer = 0;
                        self.id_checkbox_items = [];

                        return true;
                    }

                }
                if (this.refer_person == null) {
                    console.log("validate form is false" + this.validate_errors);

                    return true;
                }
                let url;
                // if (this.status_form == 0) {
                url = "AddFactorRefer";
                // }
                if (this.submit_refer != -1) {
                    const formData = new FormData();

                    formData.append('PersonId', this.refer_person);

                    formData.append('MasterFactorId', this.submit_refer);
                    axios.post(url, formData, {}).then((res) => {


                        self.submit_refer = 0;
                        self.id_checkbox_items = [];

                        self.refer_person = null;

                        self.$root.modal_component.show_api_response_modals(res);
                        self.get_all_data()
                    })
                        .catch(function (error) {

                            console.log(error);
                        });
                } else {
                    self.id_checkbox_items.forEach((val) => {

                        const formData = new FormData();

                        formData.append('PersonId', this.refer_person);

                        formData.append('MasterFactorId', val);
                        axios.post(url, formData, {}).then((res) => {


                        })
                            .catch(function (error) {

                                console.log(error);
                            });
                    });
                    self.id_checkbox_items = [];
                    self.submit_refer = 0;
                    self.id_checkbox_items = [];

                    self.refer_person = null;

                    this.get_all_data()
                }


            },

        },

    }

</script>
